var _rect, _path, _polygon, _polygon2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _polygon3, _path2, _polygon4, _path3, _path4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    width: 29,
    height: 29,
    id: "Layer_1",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 17,
    width: 11.5,
    x: 12,
    y: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,21h-10c-0.2763672,0-0.5-0.2236328-0.5-0.5s0.2236328-0.5,0.5-0.5H23V4h-9.5   C13.2236328,4,13,3.7763672,13,3.5S13.2236328,3,13.5,3h10C23.7763672,3,24,3.2236328,24,3.5v17   C24,20.7763672,23.7763672,21,23.5,21z",
    fill: "#177848"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#177848",
    points: "14,0 0,2.6086957 0,21.391304 14,24  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    opacity: 0.2,
    points: "0,2.6087036 0,2.8587036 14,0.25 14,0  "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#177848",
    height: 2,
    width: 4,
    x: 13,
    y: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#177848",
    height: 2,
    width: 4,
    x: 18,
    y: 5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#177848",
    height: 2,
    width: 4,
    x: 13,
    y: 8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "#177848",
    height: 2,
    width: 4,
    x: 18,
    y: 8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    fill: "#177848",
    height: 2,
    width: 4,
    x: 13,
    y: 11
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    fill: "#177848",
    height: 2,
    width: 4,
    x: 18,
    y: 11
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    fill: "#177848",
    height: 2,
    width: 4,
    x: 13,
    y: 14
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    fill: "#177848",
    height: 2,
    width: 4,
    x: 18,
    y: 14
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    fill: "#177848",
    height: 2,
    width: 4,
    x: 13,
    y: 17
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    fill: "#177848",
    height: 2,
    width: 4,
    x: 18,
    y: 17
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.1,
    points: "0,21.3912964 14,24 14,23.75 0,21.1412964  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_1_",
    x1: 9.5,
    x2: 23.3536377,
    y1: 7.5,
    y2: 21.3536377
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,21c0.2763672,0,0.5-0.2236328,0.5-0.5V13L14,3v18H23.5z",
    fill: "url(#SVGID_1_)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "7.357666,12.5 9.6552734,8.3642578 9.6262817,8.3481445 7.8796387,8.4729004 6.5,10.9562378    5.225647,8.6624756 3.5758667,8.7802734 5.642334,12.5 3.5758667,16.2197266 5.225647,16.3375244 6.5,14.0437622    7.8796387,16.5270996 9.6262817,16.6518555 9.6552734,16.6357422  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(60.9756088 0 0 60.9756088 20560.1210938 -26748.4140625)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_2_",
    x1: -337.1860046,
    x2: -336.9563904,
    y1: 438.8707886,
    y2: 438.8707886
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14,0L0,2.6086957v18.782608L14,24V0z",
    fill: "url(#SVGID_2_)",
    opacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_3_",
    x1: -1.5634501,
    x2: 25.0453987,
    y1: 5.9615331,
    y2: 18.369442
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,3H14V0L0,2.6087036v18.7825928L14,24v-3h9.5c0.2763672,0,0.5-0.2236328,0.5-0.5v-17   C24,3.2236328,23.7763672,3,23.5,3z",
    fill: "url(#SVGID_3_)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.34408b050dc6bc5951e2a3a55f9ae746.svg";
export { ForwardRef as ReactComponent };